<template>
  <div aspect-ratio="2" class="loginBackground">
    <v-layout wrap align-center justify-center fill-height>
      <v-container>
        <!-- Agreement modal start -->
        <v-dialog
          v-model="agreementDialog"
          max-width="500px"
          scrollable
        >
          <v-card>
            <v-card-title class="lighten-2 textDefaultColor justify-center font-weight-bold">
              {{ $t("title.agreementTitle") }}
              <div style="font-size:12px" class="greyColorDark--text font-weight-regular">Onaylamak için sayfanın en altına inmeniz gerekmektedir.</div>
            </v-card-title>

            <v-divider />

            <v-card-text v-if="this.agreementTexts.length < 0">
              <div>{{ $t("description.noContent") }}</div>
            </v-card-text>

            <v-card-text v-else  style=" max-height: 900px;">
              <div
                v-for="(agreementItem, index) in agreementTexts"
                :key="index"
              >
                <div class="defaultColor--text font-weight-bold my-4">
                  {{ agreementItem.Title }}
                </div>
                <div class="defaultColor--text mb-4">
                  {{ agreementItem.Text }}
                </div>
              </div>

              <v-btn
                elevation="0"
                class="defaultColor text-capitalize mb-4 mt-2"
                rounded
                dark
                x-large
                block
                @click="confirmAgreement"
              >
                {{ $t("buttons.confirm") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Agreement password modal end -->
        <!-- Forgot Information modal start -->
        <v-dialog v-model="forgotInfoDialog" max-width="400px">
          <v-card class="pa-5 rounded-lg">
            <v-card-text>
              <div class="defaultColor--text font-weight-bold text-center my-4">
                {{ $t("description.forgotInformation") }}
              </div>
            </v-card-text>

            <v-card-actions class="pb-4 pr-5 align-center justify-center">
              <v-btn
                elevation="0"
                class="defaultColor text-capitalize mb-4 px-12 mx-2"
                rounded
                dark
                large
                @click="forgotInfoDialog = false"
              >
                {{ $t("buttons.ok") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Forgot Information modal  end -->
        <!-- Forgot password modal start -->
        <v-dialog v-model="forgotPasswordModalStatus" max-width="500px">
          <v-card>
            <v-card-title
              class="headline font-weight-medium text-center orange--text"
            >
              {{ $t("title.forgotPassword") }}
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-container>
                <ValidationObserver ref="observer" v-slot="{ invalid }">
                  <form @submit.prevent="resetPasswordSend">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <ValidationProvider
                          :name="$t('labels.sicilNumber')"
                          rules="required"
                          v-slot="{ errors }"
                          v-if="!isVerificationSend"
                        >
                          <v-text-field
                            v-model="username"
                            :label="$t('labels.sicilNumber')"
                            :error-messages="errors[0]"
                          ></v-text-field>
                        </ValidationProvider>
                        <ValidationProvider
                          :name="$t('labels.userPhoneNumber')"
                          rules="required|max:10"
                          v-slot="{ errors }"
                          v-if="!isVerificationSend"
                        >
                          <v-text-field
                            v-model="phoneNumber"
                            :label="$t('labels.userPhoneNumber')"
                            :error-messages="errors[0]"
                            :hint="$t('description.forgotPasswordPhoneNumber')"
                            persistent-hint
                          ></v-text-field>
                        </ValidationProvider>
                        <ValidationProvider
                          :name="$t('labels.verificationCode')"
                          rules="required|max:6"
                          v-slot="{ errors }"
                          v-if="isVerificationSend"
                        >
                          <v-text-field
                            v-model="forgotPasswordCode"
                            :label="$t('labels.verificationCode')"
                            :error-messages="errors[0]"
                            :counter="6"
                            persistent-hint
                          ></v-text-field>
                        </ValidationProvider>
                        <ValidationProvider
                          :name="$t('labels.newPassword')"
                          rules="required|max:10"
                          v-slot="{ errors }"
                          v-if="isVerificationSend"
                        >
                          <v-text-field
                            v-model="newPassword"
                            :label="$t('labels.newPassword')"
                            :error-messages="errors[0]"
                            :counter="24"
                            :append-icon="
                              showNewPassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showNewPassword ? 'text' : 'password'"
                            @click:append="showNewPassword = !showNewPassword"
                            persistent-hint
                          ></v-text-field>
                        </ValidationProvider>
                        <ValidationProvider
                          :name="$t('labels.reNewPassword')"
                          rules="required|max:10"
                          v-slot="{ errors }"
                          v-if="isVerificationSend"
                        >
                          <v-text-field
                            v-model="reNewPassword"
                            :label="$t('labels.reNewPassword')"
                            :error-messages="errors[0]"
                            :counter="24"
                            :append-icon="
                              showReNewPassword ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :type="showReNewPassword ? 'text' : 'password'"
                            @click:append="
                              showReNewPassword = !showReNewPassword
                            "
                            persistent-hint
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-row>
                          <v-spacer />
                          <!-- @click="resetPasswordSend()" -->
                          <v-btn
                            color="purple darken-1"
                            class="white--text mr-3"
                            @click="
                              !isVerificationSend
                                ? resetPasswordSend()
                                : confirmNewPasswordSend()
                            "
                            :loading="loadings.forgotPasswordBtnLoading"
                            :disabled="invalid"
                          >
                            {{
                              !isVerificationSend
                                ? $t("buttons.send")
                                : $t("buttons.confirm")
                            }}
                          </v-btn>
                          <v-btn
                            color="purple darken-1"
                            text
                            dark
                            @click="
                              forgotPasswordModalStatus = false;
                              clearModal();
                            "
                          >
                            {{ $t("buttons.cancel") }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </form>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-card-actions class="pb-4 pr-5"> </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Forgot password modal end -->
        <!-- SMS validation modal start -->
        <v-dialog v-model="smsValidationDialogStatus" max-width="500px">
          <v-card>
            <v-card-title
              class="headline font-weight-medium text-center orange--text"
            >
              {{ $t("labels.verificationCode") }}
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-container>
                <ValidationObserver ref="observer" v-slot="{ invalid }">
                  <form @submit.prevent="sendVerificationCode">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <ValidationProvider
                          :name="$t('labels.verificationCode')"
                          rules="required|max:6"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="verificationCode"
                            :label="$t('labels.verificationCode')"
                            :error-messages="errors[0]"
                            type="numder"
                            counter="6"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-row>
                          <v-spacer />
                          <v-btn
                            color="blue darken-1"
                            class="white--text mr-3"
                            @click="sendVerificationCode()"
                            :loading="loadings.smsBtnLoading"
                            :disabled="invalid"
                          >
                            {{ $t("buttons.send") }}
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            dark
                            @click="
                              smsValidationDialogStatus = false;
                              clearModal();
                            "
                          >
                            {{ $t("buttons.cancel") }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </form>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-card-actions class="pb-4 pr-5"> </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- SMS validation modal end -->
        <!-- Main page content start -->
        <v-layout wrap align-center justify-center fill-height>
          <v-card
            style="background-color: rgba(0, 0, 0, 0)"
            max-width="900"
            class="rounded-lg py-10 px-10 mx-4"
            flat
          >
            <v-row no-gutters>
              <v-col md="12" xs="12">
                <div class="mb-8 px-3">
                  <v-img
                    max-width="250"
                    :src="require('@/../public/images/bsp-logo.png').default"
                    style="margin-left: auto; margin-right: auto"
                    contain
                  ></v-img>
                  <div>{{this.global}}</div>
                </div>
                <div max-width="300">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(sendLogin)">
                      <ValidationProvider
                        :name="$t('labels.sicilNumber')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="username"
                          rounded
                          outlined
                          :label="$t('labels.sicilNumber')"
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>

                      <ValidationProvider
                        :name="$t('labels.password')"
                        rules="required|min:4|max:24"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="password"
                          :label="$t('labels.password')"
                          rounded
                          outlined
                          :error-messages="errors[0]"
                          :counter="24"
                          :append-icon="
                            showPassword ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                        ></v-text-field>
                      </ValidationProvider>
                      <v-layout column wrap align-center class="pa-3">
                        <v-row no-gutters>
                          <v-col
                            sm="1"
                            md="1"
                            xs="1"
                            style="cursor: pointer"
                            @click="agreementDialog = true"
                          >
                            <v-checkbox
                              v-model="checkboxAgreement"
                              color="defaultColor"
                              :disabled="agreementCheckboxDisabled"
                            >
                            </v-checkbox>
                          </v-col>
                          <v-col
                            sm="11"
                            md="11"
                            xs="11"
                            class="d-flex align-center justify-center mx-auto"
                          >
                            <span
                              @click="agreementDialog = true"
                              class="font-weight-bold defaultColor--text"
                              style="cursor: pointer"
                              >{{ $t("description.agreementTexts") }}
                              <span
                                class="defaultColor--text font-weight-light"
                              >
                                {{ $t("description.readAndApproval") }}</span
                              ></span
                            >
                          </v-col>
                        </v-row>
                        <v-row> </v-row>
                      </v-layout>
                      <v-layout
                        class="mt-6"
                        justify-center
                        column
                        wrap
                        align-center
                      >
                        <v-btn
                          elevation="0"
                          :disabled="!checkboxAgreement"
                          class="defaultColor text-capitalize mb-4"
                          rounded
                          :dark="checkboxAgreement"
                          x-large
                          block
                          type="submit"
                          :loading="loadings.loginBtnLoading"
                        >
                          {{ $t("buttons.login") }}
                        </v-btn>

                        <v-btn
                          elevation="0"
                          class="text-capitalize font-weight-bold"
                          color="defaultColor"
                          block
                          rounded
                          text
                          dark
                          @click="forgotInfoDialog = true"
                        >
                          {{ $t("buttons.forgotMyInfo") }}
                        </v-btn>
                      </v-layout>
                    </form>
                  </ValidationObserver>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-layout>
        <!-- Main page content end -->
      </v-container>
    </v-layout>
  </div>
</template>
<script>
import AccountService from "@/services/AccountService";
import { mapActions, mapState } from "vuex";
export default {
  mounted() {},
  data() {
    return {
      //#region Loading object
      loadings: {
        loginBtnLoading: false,
        smsBtnLoading: false,
        forgotPasswordBtnLoading: false,
      },
      //#endregion

      //#region Page variables

      //Login variables
      username: "",
      password: "",
      verificationCode: "1997",
      showPassword: false,
      showNewPassword: false,
      showReNewPassword: false,

      //Forgot password variables
      phoneNumber: "",
      forgotPasswordCode: "",
      newPassword: "",
      reNewPassword: "",
      isVerificationSend: false,
      //#endregion

      //#region Modal status
      forgotPasswordModalStatus: false,
      smsValidationDialogStatus: false,
      //#endregion

      //agreement
      agreementDialog: false,
      checkboxAgreement: false,
      agreementTexts: [],
      agreementCheckboxDisabled: true,

      //forgotInfo
      forgotInfoDialog: false,
      scroll: 0,
      confirmButtonDisabled: true,

      global:''
    };
  },
  components: {},
  methods: {
    ask() {
      console.log("ok");
    },
    clearModal() {
      this.username = "";
      this.phoneNumber = "";
      this.password = "";
      this.verificationCode = "";
      this.forgotPasswordCode = "";
      this.newPassword = "";
      this.reNewPassword = "";
      this.isVerificationSend = false;

      //Reset modal observer status
      this.$refs.observer.reset();
    },

    //Two factor auth second step
    sendLogin() {
      this.loadings.loginBtnLoading = true;
      let data = {
        username: this.username,
        password: this.password,
      };
      this.loginWithoutSms(data)
        .then((res) => {
          this.getNotifications();
          this.getTagList();
          this.authSocketConnection(this.$store.state.token);
          this.$router.push("/home");
        })
        .catch((err) => {
          console.log("Login error > ", err);
        })
        .then(() => {
          this.loadings.loginBtnLoading = false;
        });
    },
    //Two factor auth second step
    sendVerificationCode() {
      this.loadings.smsBtnLoading = true;
      let body = {
        Username: this.username,
        Password: this.password,
        VerificationCode: this.verificationCode,
      };

      this.confirmLogin(body)
        .then((res) => {
          console.log("SMS Verification >", res);
          this.getNotifications();
          this.getTagList();
          this.authSocketConnection(this.$store.state.token);
          this.$router.push("/home");
        })
        .catch((err) => {
          console.log("SMS Verification error > ", err);
        })
        .then(() => {
          this.loadings.smsBtnLoading = false;
        });
    },
    //Sends user information for validation code
    resetPasswordSend() {
      this.loadings.forgotPasswordBtnLoading = true;
      let body = {
        Username: this.username,
        Phone: this.phoneNumber,
        SendCodeMailOrSMS: "sms",
      };

      this.resetPassword(body)
        .then((res) => {
          console.log("Password reset > ", res);
        })
        .catch((err) => {
          console.log("Password reset error > ", err);
        })
        .then(() => {
          this.loadings.forgotPasswordBtnLoading = false;
          this.isVerificationSend = true;
          this.$refs.observer.reset();
        });
    },

    //Not two factor Auth
    confirmNewPasswordSend() {
      this.loadings.forgotPasswordBtnLoading = true;
      let body = {
        FromCodeMailOrSMS: "sms",
        VerificationCode: this.forgotPasswordCode,
        NewPassword: this.newPassword,
        AgainNewPassword: this.reNewPassword,
        Phone: this.phoneNumber,
      };

      this.confirmNewPassword(body)
        .then((res) => {
          console.log("confirm new pass > ", res);
          this.$router.push("/home");
        })
        .catch((err) => {
          console.log("confirm new pass error > ", err);
        })
        .then(() => {
          this.loadings.forgotPasswordBtnLoading = false;
        });
    },

    //get KVKK
    getServiceText() {
      AccountService.getKvkkText()
        .then((res) => {
          console.log("kvkk text: ", res.data);
          this.agreementTexts = res.data.Result;
        })
        .catch((err) => {
          console.log("err :", err);
          showError(err);
        })
        .then(() => {});
    },

    confirmAgreement() {
      this.agreementDialog = false;
      this.checkboxAgreement = true;
      this.agreementCheckboxDisabled = false;
      this.agreementDialog = false;
    },

    ...mapActions([
      "login",
      "confirmLogin",
      "loginWithoutSms",
      "resetPassword",
      "confirmNewPassword",
      "getTagList",
      "getNotifications",
      "authSocketConnection",
    ]),
  },
  destroyed() {},
  mounted() {
    this.getServiceText();
    //Dialogta ok tuşları ile scroll yapabilmesi için
    window.addEventListener("keydown", (e) => {
      if (this.agreementDialog == true) {
        let classElement = document.getElementsByClassName("v-card__text")[0]
        let scrollHeight = classElement.scrollHeight
        let scroll = this.scroll;
        if (e.key == "ArrowDown" && scrollHeight && scroll <= scrollHeight) {
          scroll = scroll + 500;
        } else if (e.key == "ArrowUp" && scrollHeight && scroll >= 0) {
          scroll = scroll - 500;
        }
        classElement.scrollBy({top: scroll});
      }
    });

    fetch('appsettings.json')
     .then(response => response.json())
     .then(json => {this.global = json.name});
  },
};
</script>

<style>
.v-card__text::-webkit-scrollbar {
    width: 15px !important;
}
</style>
